import React, { useState } from 'react';
import { NavLink } from 'react-router-dom'; // import NavLink
import '../CSS/Header.css';
import libra_logo from "../assets/libra_logo.png";
import { FaBars, FaTimes } from "react-icons/fa";
 
const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
 
  return (
    <header className="site-header">
<div className="logo">
  <NavLink to="/">
    <img src={libra_logo} alt="Libra Logo" />
  </NavLink>
</div>
 
      <nav className={`nav-menu ${menuOpen ? 'open' : ''}`}>
        <ul>
          <li><NavLink to="/" end>Home</NavLink></li>
          <li><NavLink to="/AboutUs">About Us</NavLink></li>
          <li><NavLink to="/events">Events</NavLink></li>
          <li><NavLink to="/EvaBanquet">Eva Banquet</NavLink></li>
          <li><NavLink to="/venues">Venues</NavLink></li>
          <li><NavLink to="/gallery">Gallery</NavLink></li>
          <li><NavLink to="/blog">Blogs</NavLink></li>
          <li className="contact-button">
            <NavLink to="/contactus">Contact</NavLink>
          </li>
        </ul>
      </nav>
 
      <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>
    </header>
  );
};
 
export default Header;